import {
  type AdminPermissions,
  AdminUserPermissions,
  SocietyAdminPermissions,
} from "shared/admin-permissions/permissionNames";

const adminUserPermissionValues = Object.values(
  AdminUserPermissions,
) as string[];
const societyAdminPermissionValues = Object.values(
  SocietyAdminPermissions,
) as string[];
const adminPermissionValues = new Set<string>([
  ...adminUserPermissionValues,
  ...societyAdminPermissionValues,
]);

/** Narrows an arbitrary string to a known permission. */
export const isAdminPermission = (value: string): value is AdminPermissions =>
  adminPermissionValues.has(value);

/** Narrows a permission to one stored on the admin user rather than per society. */
export const isAdminUserPermission = (
  value: string,
): value is AdminUserPermissions => adminUserPermissionValues.includes(value);

/** Narrows a permission to one stored per society. */
export const isSocietyAdminPermission = (
  value: string,
): value is SocietyAdminPermissions =>
  societyAdminPermissionValues.includes(value);
